const baseItemSlots = [
  'main_hand',
  'off_hand',
  'head',
  'neck',
  'shoulder',
  'back',
  'chest',
  'wrist',
  'hands',
  'waist',
  'legs',
  'feet',
] as const

export const itemSlots = [...baseItemSlots, 'finger', 'trinket'] as const

export const itemSlotLabels = {
  head: 'Helm',
  neck: 'Neck',
  shoulder: 'Shoulder',
  back: 'Cloak',
  chest: 'Chest',
  wrist: 'Wrist',
  hands: 'Gloves',
  waist: 'Belt',
  legs: 'Legs',
  feet: 'Boots',
  finger: 'Ring',
  finger_1: 'Ring',
  finger_2: 'Ring',
  trinket: 'Trinket',
  trinket_1: 'Trinket',
  trinket_2: 'Trinket',
  main_hand: 'Main hand',
  off_hand: 'Off hand',
  ranged: 'Ranged weapon',
  relic: 'Relic',
  tier: 'Tier',
}

type ItemSlot = typeof itemSlots[number]
export default ItemSlot

export const itemEquipmentSlots = [
  ...baseItemSlots,
  'finger_1',
  'finger_2',
  'trinket_1',
  'trinket_2',
] as const

export type ItemEquipmentSlot = typeof itemEquipmentSlots[number]
